import React, { useEffect, useRef } from 'react';

export default function useStateRef(state) {
  const ref = useRef();

  useEffect(() => {
    ref.current = state;
  }, [state]);

  return ref;
}
